// Event Bus
const eventBus = {
  // On [event]
  on(event, callback) {
    document.addEventListener(event, (e) => callback(e.detail));
  },

  // Dispatch [event]
  dispatch(event, data) {
    document.dispatchEvent(new CustomEvent(event, { detail: data }));
  },

  // Remove [event]
  remove(event, callback) {
    document.removeEventListener(event, callback);
  }
};

// Export/expose module
export default eventBus;
